import React, { Component } from "react";
import { Helmet } from 'react-helmet'
import PageTitle from "../../components/PageTitle";
import ServiceDetail from "../../components/ServiceDetail";
import queryString from "query-string";
import services from "../../data/Services.json"
import { withRouter } from "react-router-dom";

class ServiceDetails extends Component {
	async componentDidMount() {
	}
	render() {
		const query = queryString.parse(window.location.search);
		const service = query.service;
		let details = {}
		if (service === "web") {
			details = services.web
		}
		else if (service === "mobile") {
			details = services.mobile
		}
		else if (service === "ecommerce") {
			details = services.ecommerce
		}
		else if (service === "cloud") {
			details = services.cloud
		}
		else if (service === "uiux") {
			details = services.uiux
		}
		else if (service === "qa") {
			details = services.qa
		}
		else if (service === "support") {
			details = services.support
		}
		else if (false) {

		} else {
			this.props.history.push("Services");
		}
		return (
			<div>
				<Helmet>
					<title>AsritSolutions |  {details.title}</title>
					
				</Helmet>
				<div>
					<PageTitle title={details.title} />

					<ServiceDetail details={details} />
				</div>
			</div>
		);
	}
}

export default withRouter(ServiceDetails);